"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataAnchorAddressKey = dataAnchorAddressKey;
exports.adjudicationSubjectComponent = adjudicationSubjectComponent;
exports.computeErrorFingerprint = computeErrorFingerprint;
exports.computeAdjudicationItemKey = computeAdjudicationItemKey;
const consensus_types_1 = require("../Consensus/consensus.types");
const COMPONENT_SEPARATOR = '\x1F';
const NULL_COMPONENT = '\x00';
const NO_PROPOSAL_COMPONENT = '\x02';
function dataAnchorAddressKey(address) {
    return [
        address.packageId,
        address.sliceKey,
        String(address.sliceVersion),
        address.anchor.kind,
        address.anchor.rowKey,
        address.anchor.kind === consensus_types_1.AnchorKind.Field ? address.anchor.column : NULL_COMPONENT,
    ].join(COMPONENT_SEPARATOR);
}
function adjudicationSubjectComponent(datum) {
    if (datum === null) {
        return NO_PROPOSAL_COMPONENT;
    }
    if (datum.kind === consensus_types_1.AnchorKind.Row) {
        return datum.existence;
    }
    return datum.value.normalized ?? NULL_COMPONENT;
}
async function computeErrorFingerprint(address, datum) {
    const subject = datum.kind === consensus_types_1.AnchorKind.Row ? NULL_COMPONENT : (datum.value.normalized ?? NULL_COMPONENT);
    return sha256Hex([dataAnchorAddressKey(address), subject].join(COMPONENT_SEPARATOR));
}
async function computeAdjudicationItemKey(address, proposedValue) {
    return sha256Hex([dataAnchorAddressKey(address), adjudicationSubjectComponent(proposedValue)].join(COMPONENT_SEPARATOR));
}
async function sha256Hex(input) {
    const bytes = new TextEncoder().encode(input);
    const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}
//# sourceMappingURL=package-data-identity.js.map